export const canTransferJob = (request, currentInstaller, userRole) => {
  // Transfer is available for admin, owner, manager in early states (before work has started)
  const transferableStates = ['new', 'estimated', 'accepted', 'scheduled'];
  const transferRoles = ['admin', 'owner', 'manager'];
  return (
    transferRoles.includes(userRole) &&
    transferableStates.includes(request.currentState) &&
    request.assignedTo === currentInstaller.installer_id
  );
};